<script setup>
const props = defineProps({
  values: { type: Array, default: () => [] },
  modelValue: { type: Array, default: () => [] },
});

const emit = defineEmits(['update:modelValue']);

function optKey(opt) {
  return typeof opt === 'object' ? opt.key : opt;
}
function optLabel(opt) {
  return typeof opt === 'object' ? opt.label : opt;
}

function toggle(opt) {
  const key = optKey(opt);
  const current = props.modelValue ?? [];
  const next = current.includes(key)
    ? current.filter(v => v !== key)
    : [...current, key];
  emit('update:modelValue', next);
}
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <label
      v-for="opt in values"
      :key="optKey(opt)"
      class="flex items-center gap-2 text-sm text-n-slate-12 cursor-pointer"
    >
      <input
        type="checkbox"
        :checked="modelValue?.includes(optKey(opt))"
        class="w-3.5 h-3.5 accent-n-brand cursor-pointer"
        @change="toggle(opt)"
      />
      {{ optLabel(opt) }}
    </label>
  </div>
</template>
